import { Injectable } from '@angular/core';
import {
    ActivatedRouteSnapshot,
    CanActivate,
    Router,
    RouterStateSnapshot,
    UrlTree
} from '@angular/router';
import jwtDecode from 'jwt-decode';
import { KeycloakAuthGuard, KeycloakService } from 'keycloak-angular';
import { DecodedToken } from '../state/session/session.store';
import { AppConfigQuery } from '../state/app-config/app-config.query';

@Injectable({
    providedIn: 'root'
})
export class KeycloakAccessRightGuard extends KeycloakAuthGuard implements CanActivate {
    constructor(
        protected router: Router,
        protected readonly keycloak: KeycloakService,
        private appConfig: AppConfigQuery
    ) {
        super(router, keycloak);
    }

    async isAccessAllowed(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Promise<boolean | UrlTree> {
        if (!this.appConfig.get().useLatestKeycloakFlow) return true;
        else if (this.authenticated) {
            const token = await this.keycloakAngular.getToken();
            const decoded = jwtDecode<DecodedToken>(token);
            return decoded.scope
                .split(' ')
                ?.some((r) => route.routeConfig.data?.accessRights?.indexOf(r) >= 0);
        }
    }
}
